// CSS Modules - component class name prefix: Search__

<template>
  <div :class="$style.search">
    <input
      ref="inputField"
      type="text"
      v-model="inputField"
      :placeholder="searchPlaceholder"
      maxlength="30"
      :class="$style.globalSearch"
      @input.prevent="handleChange"
      @keyup.delete="handleReset"
      @keyup.up="handleKeyUpUp"
      @keyup.down="handleKeyUpDown"
      @keyup.enter="handleKeyUpEnter"
      aria-label="searchphrase"
    />
    <div :class="$style.label" @click.prevent="handleSubmit">
      <input
        type="submit"
        :title="searchPlaceholder"
        value=""
        :class="$style.submitButton"
        aria-label="submit searchphrase"
      />
      <i class="fas fa-search"></i>
    </div>
    <div v-if="isLoading" :class="$style.loadingSpinner">
      <Loading :size="20" color="#ccc" />
    </div>
    <div v-if="didYouMean" :class="$style.didYouMean">
      {{ didYouMeanLabel }}
      <span
        v-text="didYouMean"
        :class="$style.didYouMeanPhrase"
        @click="handleDidYouMeanClick"
      />
    </div>
  </div>
</template>

<script>
import Loading from "../Loading/Loading";

export default {
  name: "Search",
  components: {
    Loading
  },
  props: {
    searchPlaceholder: {
      type: String
    },
    selectedSuggestion: {
      type: String
    },
    model: {
      type: Array,
      default: () => []
    },
    showDidYouMean: {
      type: Boolean,
      default: false
    },
    searchSynonymSuggest: {
      type: Array,
      default: () => []
    },
    searchSynonym: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      inputField: "",
      didYouMeanLabel: window.dictionary.didYouMean
    };
  },
  computed: {
    didYouMean: function() {
      if (!this.showDidYouMean) {
        return false;
      } else if (this.searchSynonym) {
        return this.searchSynonym;
      } else if (this.searchSynonymSuggest.length > 0) {
        return this.searchSynonymSuggest.join(" ");
      }
      return false;
    }
  },
  methods: {
    handleDidYouMeanClick() {
      this.inputField = this.didYouMean;
      this.$refs.inputField.focus();
      this.handleSubmit();
    },
    handleSubmit() {
      this.$emit("submitted", this.prepareTerms());
    },
    handleKeyUpEnter() {
      this.$emit("keyUpEnter", this.prepareTerms());
    },
    prepareTerms() {
      return this.inputField.trim().split(" ");
    },
    handleKeyUpUp() {
      this.$emit("keyUpUp");
    },
    handleKeyUpDown() {
      this.$emit("keyUpDown");
    },
    handleReset() {
      this.$emit("reset", this.inputField);
    },
    handleChange() {
      this.$emit("change", this.inputField);

      if (this.inputField !== "") {
        this.$emit("active", this.inputField);
      } else {
        this.$emit("inactive", this.inputField);
      }
    }
  },
  watch: {
    selectedSuggestion: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.inputField = newValue;
      }
    }
  },
  mounted() {
    const parsedValue = this.model.toString().replace(/,/g, " ");
    this.$emit("initialize", parsedValue, true);
    this.inputField = parsedValue;
  }
};
</script>

<style module lang="scss">
@import "./Search.scss";
</style>
